import { FC } from 'react';
import { SearchAnnounceResponseDto } from 'src/openapi/les-sherpas';

import SearchResultCard from '@/shared/SearchResultCard/SearchResultCard';

import useStyles from './styles';

interface Props {
  announces: SearchAnnounceResponseDto[];
}

export const GridItems: FC<Props> = ({ announces }) => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      {announces?.map((searchResult) => (
        <SearchResultCard
          key={searchResult.id}
          searchResult={searchResult}
          isFavoriteHidden
        />
      ))}
    </div>
  );
};
